import type { QueryClient } from "@tanstack/react-query";

/**
 * Mark every cached pipeline variant for `jobId` invalidated (including inactive
 * stages) without refetching them all, then force-refetch active observers.
 * Needed under `keepPreviousData`: active-only `refetchQueries` leaves other
 * stage caches looking fresh after membership changes (bulk move, sync, import).
 */
export function bustPipelineCache(
  qc: QueryClient,
  jobId: string,
  opts?: { includeJob?: boolean },
): void {
  void qc.invalidateQueries({
    queryKey: ["pipeline", jobId],
    refetchType: "none",
  });
  void qc.refetchQueries({
    queryKey: ["pipeline", jobId],
    type: "active",
  });
  if (opts?.includeJob) {
    void qc.invalidateQueries({
      queryKey: ["job", jobId],
      refetchType: "none",
    });
    void qc.refetchQueries({
      queryKey: ["job", jobId],
      type: "active",
    });
  }
}
